export const WINDOW_EVT_RESIZE = 'window:resize';

export const windowEventHelperModule = angular
  .module('Q.helpers.window-event-helper', [])

  .run(function ($rootScope, $document, $window, $timeout) {
    function _configEvents(element, prefix, events) {
      events.forEach((evtName) => {
        const names = evtName.split(';');
        element.on(names[0], (event) => {
          names.forEach((n) => {
            $rootScope.$broadcast(`${prefix}:${n}`, event);
          });
        });
      });
    }

    _configEvents(angular.element($window), 'window', [
      'resize',
      'focus',
      'blur',
      'orientationchange;resize',
      'message',
    ]);

    _configEvents($document, 'document', ['focusin']);

    // Special case for focus out, because we usually want to see if the active element changed, which needs a delay
    $document.on('focusout', (event) => {
      $rootScope.$broadcast('document:focusout', event);
      $timeout(() => {
        $rootScope.$broadcast(
          'document:focusoutActiveElement',
          event,
          $document[0].activeElement,
        );
      }, 0);
    });

    // set up document focus events based on polling
    const doc = $document[0];
    if (angular.isFunction(doc.hasFocus)) {
      let docHadFocus = doc.hasFocus();
      $window.setInterval(function checkFocus() {
        if (docHadFocus !== doc.hasFocus()) {
          docHadFocus = doc.hasFocus();
          $rootScope.$applyAsync(() => {
            $rootScope.$broadcast(`document:${docHadFocus ? 'focus' : 'blur'}`);
          });
        }
      }, 250);
    }
  });
